// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1135":"1056a172","1434":"1056a172","3343":"1056a172","3822":"1056a172","4207":"1056a172","4998":"1056a172","6001":"1056a172","8706":"51879bb1","9457":"1056a172"}[chunkId] + ".chunk.css";
};